/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { defineMessages } from 'react-intl'

import FilterAllocatorsStep, { validateAllocatorFilters } from './FilterAllocatorsStep'

import type { StepDefinition } from './instanceConfigurationWizardTypes'

const messages = defineMessages({
  title: {
    id: `configure-allocators-step.step-title`,
    defaultMessage: `Allocators`,
  },
})

export const allocatorsStepDefinition: StepDefinition = {
  title: messages.title,

  // @ts-ignore this component is wrapped in `injectedIntl`, but it doesn't seem to be making it through to TS in this case.
  ConfigureStep: FilterAllocatorsStep,
  validateStep: validateAllocatorFilters,
}
